var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C10.2878 0 6.72437 1.47591 4.10156 4.10047C1.47606 6.72609 0.000751294 10.2869 0 14C0 17.7115 1.47656 21.275 4.10156 23.8995C6.72437 26.5241 10.2878 28 14 28C17.7122 28 21.2756 26.5241 23.8984 23.8995C26.5234 21.275 28 17.7115 28 14C28 10.2885 26.5234 6.72503 23.8984 4.10047C21.2756 1.47591 17.7122 0 14 0Z",
    fill: "url(#paint0_linear_26_23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33717 13.8522C10.419 12.0742 13.1403 10.902 14.5009 10.3355C18.3903 8.71833 19.1975 8.43745 19.7247 8.42794C19.8406 8.42608 20.0987 8.45474 20.2672 8.59091C20.4072 8.70575 20.4465 8.86106 20.4662 8.97011C20.4837 9.07905 20.5078 9.32733 20.4881 9.52114C20.2781 11.7349 19.3659 17.107 18.9022 19.5865C18.7075 20.6356 18.3203 20.9874 17.9462 21.0217C17.1325 21.0965 16.5156 20.4845 15.7281 19.9684C14.4965 19.1606 13.8009 18.6579 12.6044 17.8697C11.2219 16.9589 12.1187 16.4581 12.9062 15.64C13.1119 15.4259 16.695 12.1676 16.7628 11.872C16.7715 11.8351 16.7803 11.6973 16.6972 11.6246C16.6162 11.5518 16.4959 11.5767 16.4084 11.5964C16.2837 11.6244 14.3172 12.9255 10.5022 15.4996C9.94436 15.8833 9.43905 16.0703 8.98405 16.0605C8.4853 16.0497 7.5228 15.7778 6.80748 15.5455C5.93248 15.2605 5.23467 15.1098 5.29592 14.6257C5.32655 14.3737 5.67436 14.1158 6.33717 13.8522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_23",
    x1: 1400,
    y1: 0,
    x2: 1400,
    y2: 2800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.cb34f8b1b7b789b826c05b15199f02aa.svg";
export { ForwardRef as ReactComponent };